import { render, staticRenderFns } from "./CustomCheckboxSlider.vue?vue&type=template&id=4d6a83ca&scoped=true&lang=pug&"
import script from "./CustomCheckboxSlider.vue?vue&type=script&lang=js&"
export * from "./CustomCheckboxSlider.vue?vue&type=script&lang=js&"
import style0 from "./CustomCheckboxSlider.vue?vue&type=style&index=0&id=4d6a83ca&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6a83ca",
  null
  
)

export default component.exports